
<template>
  <b-container id="customers-container" fluid class="no-sided-margin">
    <b-row>
      <b-col class="no-sided-padding">
        <b-tabs ref="customers-tabs" v-model="tab" fill pills card>
          <b-tab title="Mancati Addebiti">
            <div>
              <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
                Visualizza gli addebiti completati e quelli non andati a buon fine presso gli Autonomous store in ordine cronologico.
              </b-alert>
            </div>
            <UnpaidInvoice />
          </b-tab>
          <b-tab title="Addebiti Completati">
            <div>
              <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
                Visualizza gli addebiti completati e quelli non andati a buon fine presso gli Autonomous store in ordine cronologico.
              </b-alert>
            </div>
            <Charge />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <div style="float: right">
      <p style="font-size: 11px">Powered by <img width="100px" src="../assets/CherryChainLogo.png" alt="CherryChain"></img></p>
    </div>
  </b-container>
</template>

<script>
import Charge from "@/components/senseiCharges/Charge.vue";
import UnpaidInvoice from "@/components/senseiCharges/UnpaidInvoice.vue";
import eventBus from "@/EventBus";

export default {
  name: 'Sensei',
  props: ['session'],
  components: {UnpaidInvoice, Charge},
  data: () => ({
    showAlert: false,
    SENSEI_ANAGRAPHIC: 0,
    SENSEI_CHARGES: 1,
    tab: 0,
  }),
  mounted() {
    eventBus.$on("show-alert", () => this.showAlert = true)
    eventBus.$on('show-charges', (charges) => {
      const tab = this.isEmpty(charges) ? this.SENSEI_ANAGRAPHIC : this.SENSEI_CHARGES;
      this.switchTab(tab)
    })
  },
  methods: {
    isEmpty(object) { return Object.keys(object).length === 0 },
    switchTab(tab) { this.tab = tab }
  }
}
</script>


<style scoped>
</style>
